import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM18.0597 7.95908C18.5478 7.47092 18.5478 6.67947 18.0597 6.19131C17.5715 5.70316 16.7801 5.70316 16.2919 6.19131L6.44209 16.0411C5.95394 16.5293 5.95394 17.3207 6.44209 17.8089C6.93025 18.297 7.7217 18.297 8.20986 17.8089L18.0597 7.95908Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }